/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Billing_Paid_PendingInputs */

const en_billing_paid_pending = /** @type {(inputs: Billing_Paid_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Payment pending — finish it from the Transactions page.`)
};

const id_billing_paid_pending = /** @type {(inputs: Billing_Paid_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pembayaran tertunda — selesaikan dari halaman Transaksi.`)
};

/**
* | output |
* | --- |
* | "Payment pending — finish it from the Transactions page." |
*
* @param {Billing_Paid_PendingInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const billing_paid_pending = /** @type {((inputs?: Billing_Paid_PendingInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Billing_Paid_PendingInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_billing_paid_pending(inputs)
	return en_billing_paid_pending(inputs)
});